import { combineReducers } from "@reduxjs/toolkit";
import streamOfPaymentPending from "./stream-of-payment-pending";

const streamOfPaymentPendingReducer = combineReducers({
  streamOfPaymentPending,
});

export default streamOfPaymentPendingReducer;
